import "./Livecommentary.css";
import { NavLink } from "react-router-dom";

const Livecommentary = ({ dark, events = [], slug, status }) => {

    const getCardIcon = (event) => {
        if (event.type === "Card") {
            return (
                <span
                    className={
                        event.detail === "Red Card"
                            ? "commentaryRed"
                            : "commentaryYellow"
                    }
                ></span>
            );
        }
        return null;
    };

    const getComment = (event) => {
        if (event.type === "Card") {
            return `${event.detail} for ${event.player?.name}`;
        }

        if (event.type === "Substitution") {
            return `${event.player?.name} runs off the pitch and ${event.assist?.name} comes in`;
        }

        if (event.type === "Goal") {
            return `Goal! ${event.player?.name} scores`;
        }

        return event.comments || "";
    };

    const createPlayerUrl = (player) => {
        return `/players/${player?.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
        }-${player?.id}`;
    };

    /* UPDATED HERE — now includes id */
    const createTeamUrl = (team) => {
        return `/teams/${team?.name
            ?.trim()
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
        }-${team?.id}`;
    };

    return (
        <div className="livecommentaryWrapper">

            {events.map((event, index) => {

                const teamUrl = createTeamUrl(event.team);

                return (
                    <div key={index} className="commentaryBlock">

                        <div
                            className="commentaryCard"
                            style={dark ? { backgroundColor: "#333333ff" } : { backgroundColor: "white" }}
                        >

                            <div className="commentaryTop">
                                <span
                                    className="minute"
                                    style={dark ? { color: "#c9c6c6ff" } : { color: "#3e3f3f" }}
                                >
                                    {event.time?.elapsed}'
                                </span>
                            </div>

                            <div className="commentaryPlayers">

                                {event.detail.includes("Substitution") ? (
                                    <nav>
                                        <span
                                            className="eventType"
                                            style={dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }}
                                        >
                                            Substitution
                                        </span>

                                        <div className="playerRow">
                                            <span className="subIn"></span>

                                            <NavLink
                                                to={createPlayerUrl(event.assist)}
                                                state={{ player: event.assist, leagueSlug: slug }}
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                <span
                                                    style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}
                                                >
                                                    {event.assist?.name}
                                                </span>
                                            </NavLink>
                                        </div>

                                        <div className="playerRow">
                                            <span className="subOut"></span>

                                            <NavLink
                                                to={createPlayerUrl(event.player)}
                                                state={{ player: event.player, leagueSlug: slug }}
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                <span
                                                    style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}
                                                >
                                                    {event.player?.name}
                                                </span>
                                            </NavLink>
                                        </div>
                                    </nav>
                                ) : (
                                    <nav>
                                        <div className="playerRow">
                                            {getCardIcon(event)}

                                            {event.detail === "Normal Goal" ? (
                                                <span
                                                    className="eventType"
                                                    style={dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }}
                                                >
                                                    Goal
                                                </span>
                                            ) : (
                                                <span
                                                    className="eventType"
                                                    style={dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }}
                                                >
                                                    {event.detail || event.type}
                                                </span>
                                            )}
                                        </div>

                                        <NavLink
                                            to={createPlayerUrl(event.player)}
                                            state={{ player: event.player, leagueSlug: slug }}
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            <span
                                                style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}
                                            >
                                                {event.player?.name}
                                            </span>
                                        </NavLink>
                                    </nav>
                                )}

                                <NavLink
                                    key={index}
                                    to={teamUrl}
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="teamSide">
                                        <span
                                            className="teamName"
                                            style={dark ? { color: "#fafafaff" } : { color: "#161819" }}
                                        >
                                            {event.team?.name}
                                        </span>
                                        <img src={event.team?.logo} alt="" />
                                    </div>
                                </NavLink>

                            </div>

                        </div>

                        {event.detail.includes("Substitution") ? (
                            <p className="pep" style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}>
                                <strong style={dark ? { color: "#c9c6c6ff" } : { color: "#3e3f3f" }}>
                                    {event.time?.elapsed}'
                                </strong>
                                {" "}Ref makes a substitution, {event.assist?.name} runs off the pitch and {event.player?.name} comes in
                            </p>
                        ) : event.detail === "Normal Goal" ? (
                            <p className="pep" style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}>
                                <strong style={dark ? { color: "#c9c6c6ff" } : { color: "#3e3f3f" }}>
                                    {event.time?.elapsed}'
                                </strong>
                                {" "}A goal by {event.player?.name}
                            </p>
                        ) : (
                            <p className="pep" style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}>
                                <strong style={dark ? { color: "#c9c6c6ff" } : { color: "#3e3f3f" }}>
                                    {event.time?.elapsed}'
                                </strong>
                                {" "}{event.detail || event.type} for {event.player?.name}
                            </p>
                        )}

                    </div>
                );
            })}

{
    status?.elapsed >= 90 &&

             <p className="finalText" style={dark ? { color: "#cececeff" } : { color: "#3e3f3fe5" }}>
                Thats it ! The referee blows the final whistle
            </p>
}
        </div>
    );
};

export default Livecommentary;